import HtmlParser from "react-html-parser"
import { metadata, SVOD_EDITO_AUTOR, SVOD_EDITO_CITATION } from "lacinetek-common/src/metadata"

export const BlockQuote = ({ block }) => {
	if (!metadata(block, SVOD_EDITO_CITATION)) {
		return null
	}

	return	<div className="quote centered large">
		<blockquote>{metadata(block, SVOD_EDITO_CITATION)}</blockquote>
		<span className="source">{HtmlParser(metadata(block, SVOD_EDITO_AUTOR))}</span>
	</div>
}
